import { Component, Input } from '@angular/core';
import { FaqService } from '../../services/faq.service';
import { FaqSurveyAnswerEnum } from '../../enums/faq-survey-answer.enum';

@Component({
  selector: 'app-faq-survey',
  templateUrl: './faq-survey.component.html',
  styleUrls: ['./faq-survey.component.scss'],
  providers: [FaqService]
})
export class FaqSurveyComponent {
  @Input() faqId: number;
  private faqRatingId: number;
  public faqSurveyAnswerOptions = FaqSurveyAnswerEnum;
  public isLoadingFaqSurveyRating: boolean;
  public hasFaqSurveyRatingError: boolean;
  public hasAnsweredFaqSurveyRating: boolean;
  public shouldDisplayFaqSurveyReason: boolean;
  public isLoadingFaqSurveyReason: boolean;
  public hasFaqSurveyReasonError: boolean;
  public hasAnsweredFaqSurveyReason: boolean;
  public faqSurveyReason = '';
  public error: any;

  get trimmedFaqSurveyReason() {
    return this.faqSurveyReason.trim();
  }

  constructor(private faqService: FaqService) {}

  public async handleFaqSurveyRatingClick(faqSurveyAnswer: FaqSurveyAnswerEnum) {
    this.isLoadingFaqSurveyRating = true;

    try {
      this.faqRatingId = await this.faqService.rateFaq(this.faqId, faqSurveyAnswer);

      if (faqSurveyAnswer === this.faqSurveyAnswerOptions.NEGATIVA) {
        this.shouldDisplayFaqSurveyReason = true;
      }
    } catch (error) {
      this.error = error;

      this.hasFaqSurveyRatingError = true;

      console.error(error);
    }

    this.hasAnsweredFaqSurveyRating = true;

    this.isLoadingFaqSurveyRating = false;
  }

  public async handleFaqSurveyReasonClick() {
    this.isLoadingFaqSurveyReason = true;

    try {
      this.faqRatingId = await this.faqService.updateFaqRating(
        this.faqId,
        this.faqSurveyAnswerOptions.NEGATIVA,
        this.faqRatingId,
        this.trimmedFaqSurveyReason
      );

      this.hasAnsweredFaqSurveyReason = true;
    } catch (error) {
      this.error = error;

      this.hasFaqSurveyReasonError = true;

      console.error(error);
    }

    this.shouldDisplayFaqSurveyReason = false;

    this.isLoadingFaqSurveyReason = false;
  }
}
